import React from 'react';
import cs from 'classnames';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { $UserFollowingTopic, $UserFollowTopicLoadmore } from 'shared/atoms';
import LoadMore from '~/components/load-more';
import { Loading } from '~/components/loading';
import HashtagCard from '~/components/simple-topic-card';
import { useTranslation } from 'react-i18next';
import { Methods } from '../../constant';
import { $CurrentUserAsAvailable, $CurrentUserLinkName } from '@user/shared/atoms/current-user';
import { useRouteLoader } from '~/utils/use-route-loader';
import { IUserFollowTopic } from 'shared/models';
import { useSEOLinkBuilder } from '~/utils/build-seo-url';

import './style.scss';

const FollowTopic: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useAtomValue($UserAgent);
  const userLinkName = useAtomValue($CurrentUserLinkName);

  const { userId } = useAtomValue($CurrentUserAsAvailable);
  const data = useAtomValue($UserFollowingTopic(userLinkName));
  const { cursor = 0, data: topicList, hasMore } = data;
  const buildSEOLink = useSEOLinkBuilder();

  const topicLoader = useRouteLoader(
    Methods.UserFollowingTopicLoadMore,
    {
      user_id: userId,
      count: 10,
      cursor,
    },
    {
      atomFamilies: {
        $UserFollowTopicLoadmore,
      },
    },
  );

  const loadData = async (): Promise<{
    data: unknown[];
  }> => {
    topicLoader.load();

    return { data: [] };
  };

  return (
    <div className={cs('user-topic', { isPC: !isMobile })}>
      <div className="user-topic-feed">
        <LoadMore
          loadData={loadData}
          isEnd={!hasMore}
          alwaysShowLoading={true}
          loadingText={<Loading variant="ball" fitParent={true} />}
          endText={topicList.length > 0 ? t('no_more_items') : t('no_content')}
          initList={topicList}
          render={() => (
            <div>
              {topicList.map((item: IUserFollowTopic, i: number) => {
                return (
                  <HashtagCard
                    key={i}
                    aHref={buildSEOLink(`/topic/${item.id}`)}
                    name={item.name}
                    isDefault={true}
                    viewsCount={item.viewsCount}
                    size={'large'}
                  />
                );
              })}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default FollowTopic;
